import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { PERMISSION_LIST } from 'common/constants/permissions';

export default () => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const permission = [
        PERMISSION_LIST.GENERAL_INFORMATION_PERMISSION,
        PERMISSION_LIST.ROLES_PERMISSION,
        PERMISSION_LIST.USERS_PERMISSION,
    ];

    const options = [
        {
            label: t('General'),
            permission: permission,
            selected: ['/company/general'].includes(pathname),
            to: '/company/general',
        },
        {
            label: t('Role', { count: 2 }),
            permission: permission,
            selected: ['/company/roles'].includes(pathname),
            to: '/company/roles',
        },
        {
            label: t('User', { count: 2 }),
            permission: permission,
            selected: ['/company/users'].includes(pathname),
            to: '/company/users',
        },
    ];

    return options;
};
